// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__217OF","header":"ClearentDisclaimer_header__eAuHI","inner":"ClearentDisclaimer_inner__35QvE"};